import { Input } from 'antd'
import { CIMSTextAreaProps } from './types'

const CIMSTextArea: React.VFC<CIMSTextAreaProps> = ({
  maxLength,
  rows,
  ...rest
}) => (
  <Input.TextArea
    showCount
    maxLength={maxLength ?? 4000}
    rows={rows ?? 3}
    {...rest}
  />
)

export default CIMSTextArea
